import { render, staticRenderFns } from "./index-category.vue?vue&type=template&id=e2d2b97e&scoped=true&"
import script from "./index-category.vue?vue&type=script&lang=js&"
export * from "./index-category.vue?vue&type=script&lang=js&"
import style0 from "./index-category.vue?vue&type=style&index=0&id=e2d2b97e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d2b97e",
  null
  
)

export default component.exports